/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AccountsModule
 */

import { Injector } from '@angular/core';

import {
    RoleCollection,
    RoleService,
    TenantCollection,
    TTenantCollection,
    TUserCollection,
    UserCollection,
    UserProfileCollection,
} from 'ajs/modules/accounts';

import {
    ROLE_COLLECTION_TOKEN,
    ROLE_SERVICE_TOKEN,
    TENANT_COLLECTION_TOKEN,
    USER_COLLECTION_TOKEN,
    USER_PROFILE_COLLECTION_TOKEN,
} from 'ajs/modules/accounts/accounts.tokens';

const $injector = '$injector';

export const userProfileCollectionProvider = {
    deps: [$injector],
    provide: UserProfileCollection,
    useFactory(injector: Injector): typeof UserProfileCollection {
        return injector.get(USER_PROFILE_COLLECTION_TOKEN);
    },
};

export const roleServiceProvider = {
    deps: [$injector],
    provide: RoleService,
    useFactory(injector: Injector): typeof RoleService {
        return injector.get(ROLE_SERVICE_TOKEN);
    },
};

export const roleCollectionProvider = {
    deps: [$injector],
    provide: RoleCollection,
    useFactory(injector: Injector): typeof RoleCollection {
        return injector.get(ROLE_COLLECTION_TOKEN);
    },
};

export const userCollectionProvider = {
    deps: [$injector],
    provide: UserCollection,
    useFactory(injector: Injector): TUserCollection {
        return injector.get(USER_COLLECTION_TOKEN);
    },
};

export const tenantCollectionProvider = {
    deps: [$injector],
    provide: TenantCollection,
    useFactory(injector: Injector): TTenantCollection {
        return injector.get(TENANT_COLLECTION_TOKEN);
    },
};

